import { render, staticRenderFns } from "./TraceabilityConfirm.template.vue?vue&type=template&id=b22b7c1a&scoped=true&"
var script = {}
import style0 from "./TraceabilityConfirm.template.vue?vue&type=style&index=0&id=b22b7c1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22b7c1a",
  null
  
)

export default component.exports